import styled from '@emotion/styled';

// Theme 타입 주석 제거 및 CSS 변수 사용
export const TemplateContainer = styled.div`
  background-color: var(--theme-paper-light); // CSS 변수 사용 (light paper)
`;

export const LanguageSelectRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 16px 32px 0;

  @media (max-width: 800px) {
    padding: 16px 20px 0;
  }
  @media (max-width: 600px) {
    padding: 16px 16px 0;
  }
`;

export const LanguageSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LanguageLabel = styled.label`
  font-size: 0.85rem;
  color: var(--theme-text-secondary);
`;

export const LanguageValue = styled.span`
  font-size: 0.9rem;
  color: var(--theme-text);
  font-weight: 500;
`;

export const MainContent = styled.main`
  max-width: 800px; 
  margin: 0 auto; 
  padding: 24px 32px; 

  /* 반응형 스타일 */
  @media (max-width: 800px) {
    padding: 20px 16px;
  }
  @media (max-width: 600px) {
    padding: 16px 12px;
  }
`;

// Description 섹션 컨테이너 스타일 수정 (CSS 변수 사용)
export const DescriptionContainer = styled.div`
  margin-top: 32px;
  padding: 24px;
  background-color: var(--my-card-background); // 변경된 이름 사용 (--theme-paper 대체)
  border: 1px solid var(--theme-border);
  border-radius: var(--theme-radius-md);

  h2 {
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 1.25rem;
    font-weight: bold;
    color: var(--theme-text);
  }

  /* 반응형 스타일 */
  @media (max-width: 600px) {
    padding: 20px;
    h2 {
      font-size: 1.1rem;
    }
  }
`;

// Description 내용 스타일 수정 (CSS 변수 사용)
export const DescriptionContent = styled.div<{ isExpanded: boolean; needsExpansion: boolean }>`
  font-size: 0.95rem;
  line-height: 1.7;
  color: var(--theme-text-secondary); // CSS 변수 사용
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s ease-out;

  /* 축소 상태 스타일 */
  ${({ isExpanded, needsExpansion }) => !isExpanded && needsExpansion && `
    max-height: 10em;
    /* 그라데이션 오버레이 (CSS 변수 사용) */
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3em;
      background: linear-gradient(to bottom, transparent, var(--my-card-background)); /* 변경된 이름 사용 */
    }
  `}

  /* 확장 상태 스타일 */
  ${({ isExpanded, needsExpansion }) => isExpanded && needsExpansion && `
    max-height: 1000px;
  `}
  
  p {
    margin-bottom: 0;
  }

  /* 반응형 스타일 */
  @media (max-width: 600px) {
    font-size: 0.9rem;
    line-height: 1.6;
  }
`;

// 더보기/간략히 보기 버튼 스타일 수정 (CSS 변수 사용)
export const ToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
  padding: 8px 16px;
  background-color: var(--my-card-background); // 변경된 이름 사용
  border: 1px solid var(--theme-border);
  border-radius: var(--theme-radius-sm);
  color: var(--theme-text-secondary);
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background-color: var(--theme-paper-hover);
    border-color: var(--theme-border-light);
    text-decoration: none;
  }

  &:focus {
    outline: 2px solid var(--theme-primary-light);
    outline-offset: 2px;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  /* 반응형 스타일 */
  @media (max-width: 600px) {
    padding: 6px 12px;
    font-size: 0.8rem;
  }
`;

// 버튼 중앙 정렬을 위한 래퍼
export const ButtonWrapper = styled.div`
  text-align: center; /* 버튼을 중앙 정렬 */
  width: 100%; /* 부모 너비 차지 */
`;
